module.exports = "<!-- <img src=\"../../../../../assets/images/chat-icon.svg\" class=\"chat-img\" (click)=\"featureUnderConstructionNavigation()\"/> -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component.html
// module id = ./src/app/feature/main/roles-shared/chat-bot-icon/chat-bot-icon.component.html
// module chunks = main